module.exports = __webpack_public_path__ + "media/application/images/svgs/mic-70f878bc0e7887985a8b926df539d80d.svg";